<template>
  <div>
    <div class="bg_box"></div>
    <div class="centerbox">
      <div class="flex-between bgwhite">
        <div class="flex">
          <div class="imgbox" v-if="userInfo.auth == 'UNPOST'">
            <img src="@/assets/images/no_cerhead.png" />
          </div>
          <div class="imgbox" v-if="userInfo.auth == 'POST'">
            <img src="@/assets/images/no_cerhead.png" />
          </div>
          <div class="imgbox" v-if="userInfo.auth == 'DONE'">
            <template v-if="userInfo.avatar">
              <img :src="userInfo.avatar" />
            </template>
            <template v-else>
              <img src="@/assets/images/people.png" />
            </template>
          </div>
          <div class="phonebox">{{ userInfo.phone }}</div>
        </div>
        <div class="statusbox" v-if="userInfo.auth == 'UNPOST'" @click="gocer">
          请认证<i class="el-icon-arrow-right"></i>
        </div>
        <div class="statusbox" v-if="userInfo.auth == 'POST'" @click="gocer">
          认证中
        </div>
        <div class="statusbox overcer" v-if="userInfo.auth == 'DONE'">
          已认证
        </div>
      </div>
      <div class="flex-between  bgwhite" @click="repas">
        <div>修改密码</div>
        <div><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="flex-between  bgwhite" @click="gobank">
        <div>银行账号</div>
        <div><i class="el-icon-arrow-right"></i></div>
      </div>
      <!-- 退出登录 -->
      <div class="loginout" @click="loginout">退出登录</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo: ""
    };
  },
  mounted() {
    const getUser = JSON.parse(localStorage.getItem("userinfo"));
    this.userInfo = getUser;
  },
  methods: {
    // 去认证
    gocer() {
      this.$router.push({ name: "certification" });
    },
    loginout() {
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("token");
      localStorage.removeItem("moible");
      localStorage.removeItem("userinfo");
      localStorage.setItem('isSevrice',0)
      this.fishkefu.logout()
      this.$router.push({ name: "login" });
 
    },
    gobank() {
      this.$router.push({ name: "bank" });
    },
    repas() {
      this.$router.push({ name: "respas" });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/index.sass";

.overcer {
  color: #ffb606;
}
.statusbox {
  padding-top: 18px;
}
.imgbox {
  margin-right: 10px;
  width: 72px;
  height: 72px;
  img {
    border-radius: 50%;
    overflow: hidden;
  }
}
.loginout {
  position: fixed;
  bottom: 20px;
  left: 10px;
  width: 90%;
  margin-left: -45%;
  left: 50%;
  text-align: center;
  border-radius: 8px;
  color: #fff;
  font-size: 36px;
  line-height: 88px;
  background: $btn_color;
  // $btn_color: #ffb606;
}
.phonebox {
  padding-top: 22px;
}
.bg_box {
  // background: red;
  background: #f7f7f7;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.bgwhite {
  font-size: 32px;
  padding: 35px 30px;
  background: #fff;
  margin-bottom: 20px;
  i {
    margin-top: 10px;
  }
}
.centerbox {
  position: relative;
  z-index: 1;
}
</style>
